import ContactForm from "../components/ContactForm";
export default function Contact(){
  return (
    <section className="section">
      <div className="container">
        <ContactForm />
      </div>
    </section>
  );
}
